import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import SingleWork from '../../components/Work';
import DataState from '../../components/DataState';
import { useCollections } from '../../lib/api/collections';


const ServiceThreeMain = () => {
  const content = useCollections('facilities');
  if (content.loading || content.error) return <DataState state={content} />;
  const facilities = content.facilities;

  return (
    <main>
      <Breadcrumb title="Campus Facilities" subTitle="Facilities" />

      <div className="it-wrok-area fix it-wrok-bg ed-work-style-2 ed-work-style-3 inner-style pt-120 pb-90">
        <div className="container container-3">
          <div className="row">
            {facilities.map((f) => (
              <div key={f.title} className="col-xl-4 col-lg-4 col-md-6 mb-30">
                <SingleWork
                  itemClass="it-work-item"
                  iconClass={f.icon}
                  title={f.title}
                  to={f.to}
                  description={f.description}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};
export default ServiceThreeMain;
